import { forwardRef } from "react";
import { HomepageBlock2 as Block } from "@circle-react-shared/BuilderUI/DefaultBlocks/Homepage/HomepageBlock2/HomepageBlock2";
import type { HomepageBlock2Props } from "@circle-react-shared/BuilderUI/DefaultBlocks/Homepage/HomepageBlock2/HomepageBlock2";

export const HomepageBlock2 = forwardRef<HTMLDivElement, HomepageBlock2Props>(
  ({ ...rest }, ref) => <Block ref={ref} {...rest} />,
);

HomepageBlock2.displayName = "HomepageBlock2";
